import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './bootstrap/dist/css/bootstrap.min.css';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Logs Core Web Vitals to the console only — no third-party analytics,
// no persistent identifiers. Swap for a first-party sendBeacon() call
// once a self-hosted collector endpoint exists.
reportWebVitals(({ name, value, rating, id }) => {
  console.log(`[web-vitals] ${name}: ${Math.round(value * 100) / 100} (${rating}) [${id}]`);
});
